export default __webpack_public_path__ + "static/media/Video.308e5b61.png";